module.exports = __webpack_public_path__ + "static/media/IMG_8759.6d513a34.JPG";